<template>
  <v-row
    no-gutters
    justify="space-between"
    style="border-top: solid thin; font-size: 8pt;"
  >
    <v-col cols="7" class="text-left text-caption pl-1">
      @2021 - GLS Denmark A/S
    </v-col>
    <v-col cols="5">
      <v-layout>
        <v-spacer />
        <div class="text-left text-caption pr-1">
          <v-row no-gutters>GLS Express A/S</v-row>
          <v-row no-gutters>Kokmose 3</v-row>
          <v-row no-gutters>6000 Kolding</v-row>
          <v-row no-gutters>CVR 14414002</v-row>
          <v-row no-gutters>Tlfnr. 70 22 70 22</v-row>
        </div>
      </v-layout>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Footer"
};
</script>
